import { type MasonryEngineActionHandler } from '@leagueplatform/masonry-engine';
import {
  MasonryDriverAction,
  MasonryDeeplinkAction,
} from '@leagueplatform/masonry-renderers';

export const masonryRedirectActionHandler: MasonryEngineActionHandler<
  MasonryDeeplinkAction,
  MasonryDriverAction
> = ({ payload: { url } }) => {
  if (!url) {
    console.warn('masonryRedirectActionHandler: No URL provided in payload');
    return;
  }

  const anchor = document.querySelector(
    `a[href="${url}"]`,
  ) as HTMLAnchorElement;
  if (anchor) {
    anchor.click();
  } else {
    window.location.href = url;
  }
};
